import React, { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  List,
  ListItemButton,
  ListItemText,
  Box,
  CircularProgress,
  Pagination,
  Typography,
} from "@mui/material";

export default function Modal({ open, onClose, items, loading, title, onSelect, pageSize = 100 }) {
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (open) {
      setQ("");
      setPage(1);
    }
  }, [open]);

  const filtered = useMemo(() => {
    const s = String(q || "").trim().toLowerCase();
    const arr = Array.isArray(items) ? items : [];
    if (!s) return arr;
    return arr.filter((x) => {
      const v = String(x?.value || "").toLowerCase();
      const l = String(x?.label || "").toLowerCase();
      return v.includes(s) || l.includes(s);
    });
  }, [items, q]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  const pageItems = useMemo(() => {
    const start = (page - 1) * pageSize;
    return filtered.slice(start, start + pageSize);
  }, [filtered, page, pageSize]);

  const handleSelect = (it) => {
    if (onSelect) onSelect(it);
    if (onClose) onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ fontWeight: 900 }}>{title || "Seleccionar"}</DialogTitle>

      <DialogContent sx={{ pt: 1.5 }}>
        <TextField
          label="Buscar"
          value={q}
          onChange={(e) => {
            setQ(e.target.value);
            setPage(1);
          }}
          fullWidth
          autoFocus
        />

        <Box sx={{ mt: 2, minHeight: 360, border: "1px solid #e6e6e6", borderRadius: 1 }}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 360 }}>
              <CircularProgress size={26} />
            </Box>
          ) : pageItems.length === 0 ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 360 }}>
              <Typography sx={{ color: "#666" }}>Sin resultados</Typography>
            </Box>
          ) : (
            <List dense sx={{ maxHeight: 360, overflow: "auto" }}>
              {pageItems.map((it) => (
                <ListItemButton key={String(it?.value ?? it?.label ?? "")} onClick={() => handleSelect(it)}>
                  <ListItemText primary={String(it?.label || it?.value || "")} />
                </ListItemButton>
              ))}
            </List>
          )}
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(_, p) => setPage(p)}
            shape="rounded"
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
